import React from 'react';
import { CheckboxProps } from 'antd';
import { StyledCheckbox } from './index.styled';

interface AppCheckboxProps extends CheckboxProps {
  useSecondaryColor?: boolean;
  size?: 'small' | 'large';
}

const AppCheckbox: React.FC<AppCheckboxProps> = ({
  useSecondaryColor = true,
  size = 'large',
  ...props
}) => {
  return (
    <StyledCheckbox
      {...props}
      className={`${props.className || ''} ${useSecondaryColor ? 'secondary-color' : ''}`}
      size={size}
    />
  );
};

export default AppCheckbox;
